import TruncatedContent from './TruncatedContent';

export default TruncatedContent;
export { TruncatedContent };
